export async function readDroppedFolder(items) {
  const allFiles = [];
  const promises = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i].webkitGetAsEntry();
    if (item) {
      promises.push(traverseFileTree(item, ""));
    }
  }

  const fileArrays = await Promise.all(promises);
  return fileArrays.flat();
}

async function traverseFileTree(item, path) {
  // Skip hidden files and directories (starting with .)
  if (item.name.startsWith(".")) {
    return [];
  }

  if (item.isFile) {
    const file = await getFile(item);
    // Create a custom property since webkitRelativePath is read-only
    file._customRelativePath = path + file.name;
    return [file];
  } else if (item.isDirectory) {
    const entries = await readEntries(item);
    const promises = entries.map((entry) =>
      traverseFileTree(entry, path + item.name + "/")
    );
    const fileArrays = await Promise.all(promises);
    return fileArrays.flat();
  }
  return [];
}

function getFile(fileEntry) {
  return new Promise((resolve) => {
    fileEntry.file(resolve);
  });
}

function readEntries(dirReader) {
  return new Promise((resolve) => {
    const reader = dirReader.createReader();
    const entries = [];

    const readBatch = () => {
      reader.readEntries((batch) => {
        if (batch.length === 0) {
          resolve(entries);
        } else {
          entries.push(...batch);
          readBatch(); // Continue reading until empty batch
        }
      });
    };

    readBatch();
  });
}
